import type { AdminApplication, AdminLicense } from "@/pages/admin/hooks/useAdminData";

interface AdminStatsProps {
  applications: AdminApplication[];
  licenses: AdminLicense[];
}

export default function AdminStats({ applications, licenses }: AdminStatsProps) {
  const pending = applications.filter((item) => item.status === "pending").length;
  const approved = applications.filter((item) => item.status === "approved").length;
  const activeLicenses = licenses.filter((item) => item.status === "active").length;
  const revoked = licenses.filter((item) => item.status === "revoked").length;

  const cards = [
    { label: "待审批申请", value: pending, icon: "ri-time-line", tone: "accent" },
    { label: "已通过申请", value: approved, icon: "ri-checkbox-circle-line", tone: "primary" },
    { label: "有效许可证", value: activeLicenses, icon: "ri-shield-check-line", tone: "primary" },
    { label: "已吊销许可证", value: revoked, icon: "ri-forbid-2-line", tone: "secondary" },
  ];

  const toneClass: Record<string, string> = {
    primary: "bg-primary-100 text-primary-700",
    accent: "bg-accent-100 text-accent-700",
    secondary: "bg-secondary-100 text-secondary-900",
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <div key={card.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
          <div className="flex items-center justify-between">
            <span className="text-xs text-foreground-600">{card.label}</span>
            <span className={`flex h-8 w-8 items-center justify-center rounded-md ${toneClass[card.tone]}`}>
              <i className={`${card.icon} text-base`} />
            </span>
          </div>
          <p className="mt-2 font-heading text-2xl font-semibold text-foreground-950">{card.value}</p>
        </div>
      ))}
    </div>
  );
}